import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET, type Schema } from "@/api/client"

export type EUEmissionsYearResponse = Schema["EUEmissionsYearResponse"]

export function euEmissionsOptions(year: number) {
	return queryOptions({
		queryKey: ["market-data", "eu-emissions", year],
		queryFn: () =>
			GET("/api/v1/market-data/eu-emissions/{year}", {
				params: { path: { year } },
			}),
		placeholderData: keepPreviousData,
	})
}

export function useEUEmissions(year: number) {
	return useQuery(euEmissionsOptions(year))
}

export function euEmissionsYearsOptions() {
	return queryOptions({
		queryKey: ["market-data", "eu-emissions", "years"],
		queryFn: () => GET("/api/v1/market-data/eu-emissions/years"),
	})
}

export function useEUEmissionsYears() {
	return useQuery(euEmissionsYearsOptions())
}
